var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "historial-tab" },
    [
      _c("section-title", {
        staticClass: "mt-4 mb-3",
        attrs: {
          "has-line": "",
          title: "Historial de Servicio",
          "title-class": "section-title-info"
        }
      }),
      _c(
        "time-line",
        { staticClass: "historial-line mt-4" },
        _vm._l(_vm.records, function(history) {
          return _c(
            "time-line-item",
            {
              key: `Proposal-${history.proposalRequestId}-ProposalHistory-${history.id}`,
              attrs: { icon: _vm.getIcon(history.trackingTypeId) },
              scopedSlots: _vm._u(
                [
                  {
                    key: "date",
                    fn: function() {
                      return [
                        _c(
                          "span",
                          { staticClass: "color-secondary-6 font-12" },
                          [_vm._v("Fecha:")]
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "color-black font-16 font-weight-bold"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$formatDate(
                                    history.createdDate,
                                    _vm.$templateDate.longDateWithHour
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            },
            [
              _c("div", { staticClass: "row", attrs: { id: "main-info" } }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-2 additional-evaluation ml-2 mt-1"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "color-gray-12 font-18 font-weight-bold" },
                      [
                        _vm._v(
                          " " + _vm._s(history.trackingTypeName || "N/A") + " "
                        )
                      ]
                    ),
                    _c("custom-pill", {
                      staticClass: "historial-tab__pill mb-3 mb-md-0",
                      attrs: {
                        "has-border": false,
                        icon: "fa-xs fas fa-circle",
                        "icon-class": `color-${_vm.getColorStatus(
                          history.proposalRequestStatusId
                        )}`,
                        text: history.statusName
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-3 mt-3 mt-md-0 mt-sm-3" },
                  [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v(" Usuario: ")
                    ]),
                    _c(
                      "div",
                      { staticClass: "color-black font-16 font-weight-normal" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("capitalize")(history.fullName)) +
                            " "
                        )
                      ]
                    )
                  ]
                ),
                _c("div", { staticClass: "col mt-3 mt-md-0 mt-sm-3" }, [
                  _c("div", { staticClass: "color-secondary-6 font-14" }, [
                    _vm._v(" Descripción: ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "color-black font-16 font-weight-normal" },
                    [_vm._v(" " + _vm._s(history.description) + " ")]
                  )
                ])
              ])
            ]
          )
        }),
        1
      ),
      _vm.currentPage !== _vm.totalPages
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center align-items-center" },
            [
              _c(
                "action-button",
                {
                  staticClass: "btn-see-more",
                  attrs: {
                    i: "fas fa-chevron-down",
                    variant: "outline-success rounded-pill"
                  },
                  on: { click: _vm.loadMore }
                },
                [_vm._v(" Ver más historial ")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }